import Vue from 'vue'
import Router from 'vue-router'
import Home from '../views/home/index.vue'
import About from '../views/about/index.vue'
import Case from '../views/case/index.vue'
import CaseMobile from '../views/case/mobile.vue'
import GLvJiMobilePage from '../views/case/components/GLvJiMobilePage.vue'
import DDuMobilePage from '../views/case/components/DDuMobilePage.vue'
import GLuMobilePage from '../views/case/components/GLuMobilePage.vue'
import ZLiuJiMobilePage from '../views/case/components/ZLiuJiMobilePage.vue'
import KYaJiMobilePage from '../views/case/components/KYaJiMobilePage.vue'
import QWeiDingZhiMobilePage from '../views/case/components/QWeiDingZhiMobilePage.vue'
import ZGuiMobilePage from '../views/case/components/ZGuiMobilePage.vue'
import Login from '../views/login/index.vue'
import Register from '../views/register/index.vue'

Vue.use(Router)

/**
 * 重写路由的push方法
 */
const routerPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home
    },
    {
      path: '/index',
      name: 'index',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/case',
      name: 'case',
      component: Case
    },
    {
      path: '/case/mobile',
      name: 'mobile',
      component: CaseMobile,
      children: [
        {
          path: 'gLvJiPage',
          name: 'gLvJiPage',
          component: GLvJiMobilePage
        },
        {
          path: 'gLuPage',
          name: 'gLuPage',
          component: GLuMobilePage
        },
        {
          path: 'zLiuJiPage',
          name: 'zLiuJiPage',
          component: ZLiuJiMobilePage
        },
        {
          path: 'zGuiPage',
          name: 'zGuiPage',
          component: ZGuiMobilePage
        },
        {
          path: 'kYaJiPage',
          name: 'kYaJiPage',
          component: KYaJiMobilePage
        },
        {
          path: 'dDuPage',
          name: 'dDuPage',
          component: DDuMobilePage
        },
        {
          path: 'qWeiDingZhiPage',
          name: 'qWeiDingZhiPage',
          component: QWeiDingZhiMobilePage
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/register',
      name: 'register',
      component: Register
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js